import {Component, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from "../base/base.component";
import {RestClient} from "../rest-client.service";
import {BsaPrepaidAutoChargeXBVO, BsaProfileInfoXBVO} from "../model/xbvo.model";
import {NgForm} from "@angular/forms";
import {HttpResponse} from "@angular/common/http";
import {saveAs} from 'file-saver-es';
import {ConfirmationService} from "primeng/api";
import {Messages} from "primeng/messages";

/**
 * App-Component
 */
@Component({
    selector: '<skitbs-prepaid>',
    templateUrl: 'prepaid.component.html'
})
export class PrepaidComponent extends BaseComponent implements OnInit {

    @ViewChild('formEdit') public editForm: NgForm;
    modelXBVO: BsaPrepaidAutoChargeXBVO;


    /**
     * Constructor.
     * @param restClient
     */
    constructor(private restClient: RestClient, private confirmationService: ConfirmationService) {
        super();
    }

    /**
     * Lifecycle.
     */
    ngOnInit(): void {
        this.onSearch();
    }


    /**
     * Action.
     */
    public onChargeOnce(aAmount: number) {
        this.confirmationService.confirm({
            message: this.v('pleaseConfirm') + " <b>€" + aAmount + "</b>",
            accept: () => {
                // REST-call
                this.restClient.prepaidChargeOnce(aAmount).subscribe(aResponse => {
                    this.toastInfo(this.v("operationComplete"));
                    this.onSearch()
                });
            }
        });
    }

    /**
     * Action.
     */
    public onSetAutocharge(aAmount: number) {
        let pMsg = aAmount > 0 ? "€" + aAmount : this.v('deactivate');
        this.confirmationService.confirm({
            message: this.v('pleaseConfirm') + ": <b>" + pMsg + "</b>",
            accept: () => {
                // REST-call
                this.restClient.prepaidSetAutoChargeAmount(aAmount).subscribe(aResponse => {
                    this.toastInfo(this.v("operationComplete"));
                    this.onSearch()
                });
            }
        });
    }

    /**
     * Action.
     */
    onSearch() {
        this.restClient
            .prepaidStatus()
            .subscribe((aXBVO => this.modelXBVO = aXBVO));
    }
}
